import React from 'react';
import {DarkModeOutlined, LightModeOutlined} from "@mui/icons-material";
import {IconButton, Tooltip} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {themeActions} from "../../store/actions/themeAction";

export default function ThemeSwitch() {
    const isDarkMode = useSelector(state => state.theme.isDarkMode);
    const dispatch = useDispatch();
    const label = isDarkMode ? 'Switch to light theme' : 'Switch to dark theme';

    return (
        <Tooltip title={label}>
            <IconButton
                color="inherit"
                aria-label={label}
                aria-pressed={isDarkMode}
                onClick={() => dispatch(themeActions.setDarkMode(!isDarkMode))}
            >
                {isDarkMode ? <LightModeOutlined/> : <DarkModeOutlined/>}
            </IconButton>
        </Tooltip>
    );
}
